import * as React from 'react';
//@ts-ignore
import moment from 'moment';

import './Footer.scss';

export default class Footer extends React.PureComponent {
    render() {
        return <div className="footer"><a href="https://www.comptia.org/legal" target="_blank" rel="noreferrer">Legal</a><span>Copyright © The Computing Technology Industry Association, Inc. All rights reserved.</span></div>;
      
    }
}